export default __webpack_public_path__ + "static/media/buy-drums.0effbd5c.jpg";